import {peakAlert} from "../PeakDialog.js";
import jQuery from 'jquery';
import {SavedListingRepository} from "./saved-listings/SavedListingRepository.js";
import {InfiniteScroll, InfiniteScrollPanel} from "./infiniteScroll.js";
import { ZIDX } from "./standaloneLibrary.js";
import {IframeChildManager} from "./IframeChildManager.js";
import {acceptParentMessage, postToParent} from "./IframeParentOrigin.js";
import { LocationMegaMenu, LocationTag } from "./LocationMegaMenu.js";
import {AISearchIntegration} from "./AISearchIntegration.js";

// Re-export models so existing imports from "./base.js" keep working
export {
    ZIDXListingSummary, ZIDXListingData, ZIDXSearchFields,
    LISTING_LAYOUT_LIST, LISTING_LAYOUT_DETAIL, LISTING_LAYOUT_MAP,
    firstLetterCaps, searchIsEmbedded
} from "./ListingModels.js";
export type { ZIDXSearchCount,ZIDXAdvancedQueryResult } from "./ListingModels.js";

import {
    ZIDXListingSummary, ZIDXListingData, ZIDXSearchFields,
    LISTING_LAYOUT_LIST, LISTING_LAYOUT_DETAIL, LISTING_LAYOUT_MAP,
    searchIsEmbedded, firstLetterCaps
} from "./ListingModels.js";

import {
    numberFormat, htmlEditFormat, timestampToDateFormat, urlEncode,
    getListingURL, getLayoutString,
    renderListingThumbnailList, renderListingThumbnailDetail,
    displayListings, listingPanelRenderCallback, setupListingSearchInfiniteScroll
} from "./ListingRenderer.js";

import {
    mapArrayToObject, doSearchCallback, doSearchCountCallback,
    doSearchCallbackError, doSearchCountCallbackError,
    parseSearchData, updateListingData, parseListingIds,
    buildJsonSearch, doSearch, dedupeSearchForm, limitTo32Values,
    setCheckboxValues, decodeNativeSearch, applySearchParamsToForm,
    checkForSearchFormChanges, parseInQuery
} from "./SearchEngine.js";

import {
    getLabel, updateSearchFormLabels, updateLabelValues, updateMoreLocationLabel,
    updateSearchCounts, closeMorePopup, relocateMegaMenu,
    searchUpdateMorePopup, idxSearchResize,
    loadCurrentSearchCriteria, setupSearchForm, setupSearchFormOnce
} from "./SearchFormUI.js";

let $=jQuery.noConflict();

export class ZIDXBase {
    json: string = "";
    locationMegaMenu: LocationMegaMenu | null = null;
    lastPostObj = new ZIDXSearchFields();
    searchMorePopupOpen = false;
    mapLoaded = false;
    searchFormSetupOnce = false;
    skipMenuHitText = false;
    listingData = new ZIDXListingData();
    resetListingData = false;
    infiniteScroll: InfiniteScroll | null = null;
    arrListingSummaryFieldOrder = ["type", "id", "indexId", "price", "latitude", "longitude", "bedrooms", "bathrooms", "halfBaths", "sqft", "acreage", "address", "address2", "city", "state", "postalCode", "status", "listStatus", "photo", "createdDatetime", "showListings"];
    renderSaveButton = false;
    openInNewTab = false;
    useFreeTrial = true;
    searchDomain = "";
    iframeChildManager: IframeChildManager | null = null;
    zidx:ZIDX;
    private hiddenListingScannerInterval: number | null = null;
    aiSearchIntegration: AISearchIntegration | null = null;
    currentOffset: number = 0;
    listingDataOffsetsLoaded: any = {};
    listingDataOffsetsLoading: any = {};
    doSearchTimeout: string|number|NodeJS.Timeout = 0;
    enableFullscreenLink = true;
    megaMenuOriginalParent: HTMLElement | null = null;

    constructor(zidx:ZIDX) {
        this.zidx = zidx;
        if(searchIsEmbedded){
            $(".zidxBodyElement", this.zidx.peakidxShadowRoot).addClass("zidxEmbeddedBody");
        }
        let self=this;
        setTimeout(function(){
            self.setupIframeManager();
        }, 10);
        this.zidx.loadFunctions.push(() => {
            this.bindSaveButtons();
        });
        this.startHiddenListingScanner();
    }

    // ── Hidden listing scanner ──

    private startHiddenListingScanner() {
        if (this.hiddenListingScannerInterval !== null) {
            return;
        }
        const self = this;
        this.hiddenListingScannerInterval = window.setInterval(() => {
            self.scanAndMarkHiddenListings();
        }, 1000);
        this.scanAndMarkHiddenListings();
    }

    private scanAndMarkHiddenListings() {
        if (window.location.pathname.indexOf('/hidden-listings/') !== -1) {
            return;
        }
        const repo = SavedListingRepository.getInstance(this.zidx);
        const hiddenListings = repo.getHiddenListings();
        if (hiddenListings.length === 0) {
            return;
        }
        const hiddenByUniqueId = new Set<number>();
        const hiddenByIndexAndId = new Set<string>();
        for (const entry of hiddenListings) {
            if (entry.uniqueId !== 0) {
                hiddenByUniqueId.add(entry.uniqueId);
            }
            hiddenByIndexAndId.add(`${entry.indexId}:${entry.listingId}`);
        }
        $(".zidxSearchResultListingContainer:not(.zidxListingRemoved)", this.zidx.peakidxShadowRoot).each(function(this: HTMLElement) {
            const $container = $(this);
            const dataId = $container.attr("data-id") || "";
            const uniqueIdStr = $container.attr("data-unique-id") || "0";
            const uniqueId = parseInt(uniqueIdStr, 10);
            let isHidden = false;
            if (uniqueId !== 0 && hiddenByUniqueId.has(uniqueId)) {
                isHidden = true;
            }
            if (!isHidden && dataId && hiddenByIndexAndId.has(dataId)) {
                isHidden = true;
            }
            if (isHidden) {
                $container.addClass("zidxListingRemoved");
                $container.css({
                    "background-color": "#808080",
                    "display": "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    "min-height": "200px"
                });
                $container.hide();
                $container.empty();
                $container.append('<span style="color: white; font-size: 18px; font-weight: bold;">Removed</span>');
                $container.off("click");
                $container.css("cursor", "default");
            }
        });
    }

    // ── Iframe manager ──

    isAndroid(): boolean{
        // @ts-ignore - Check for modern Client Hints API
        const platform = navigator.userAgentData?.platform || navigator.platform;
        return /Android/i.test(platform);
    };

    setupIframeManager(){
        const self=this;
        if (self.zidx.inIframe()) {
            const container = self.zidx.peakidxShadowRoot.getElementById("zidxComponentContainer");
            const modalSelector = "#zModalOverlayDivInner1";
            console.log("new IframeChildManager()");
            self.iframeChildManager = new IframeChildManager(container, modalSelector);
            self.iframeChildManager.setNavigateCallback((url: string) => {
                console.log("[base.ts] Parent requested navigation to:", url);
                let navigateUrl: string;
                try {
                    const u = new URL(url, window.location.origin);
                    if (u.origin !== window.location.origin) return;
                    navigateUrl = u.pathname + u.search + u.hash;
                } catch (e) {
                    return;
                }
                console.log("[base.ts] Navigating to:", navigateUrl);
                self.zidx.loadPushStateURL(navigateUrl, true, true);
            });
            window.addEventListener('message', (event: MessageEvent) => {
                if (!acceptParentMessage(event)) return;
                const data = event.data;
                if ((window as any).ZIDXOptions?.hubspotEmbed && data?.type === 'PeakIDXHostReady') {
                    const container = self.zidx.peakidxShadowRoot.getElementById("zidxComponentContainer");
                    if (container) {
                        const theme = data.theme;
                        if (theme === 'dark' || theme === 'light') {
                            const dark = theme === 'dark';
                            self.zidx.options.isDarkMode = dark;
                            container.style.setProperty('--background-color', dark ? '#111111' : '#ffffff');
                            container.style.setProperty('--text-color', dark ? '#ffffff' : '#111111');
                            container.style.setProperty('--input-background-color', dark ? '#111111' : '#ffffff');
                            container.style.setProperty('--input-text-color', dark ? '#ffffff' : '#111111');
                            container.style.setProperty('--border-color', dark ? '#777777' : '#888888');
                            container.style.colorScheme = theme;
                        }
                        if (typeof data.accent === 'string' && /^#[0-9a-f]{6}$/i.test(data.accent)) {
                            container.style.setProperty('--link-color', data.accent);
                            container.style.setProperty('--button-background-color', data.accent);
                        }
                    }
                }
                if (data && data.type === 'PeakIDXWindowHeight' &&
                    Number.isFinite(data.height) && data.height >= 0 && data.height <= 100000 &&
                    Number.isFinite(data.iframeScrollY) && data.iframeScrollY >= 0 && data.iframeScrollY <= 1000000) {
                    self.zidx.windowHeight = data.height;
                    self.zidx.iframeScrollY = data.iframeScrollY;
                    if (self.zidx.scrollThrottleId) return;
                    self.zidx.scrollThrottleId = requestAnimationFrame(() => {
                        self.zidx.scrollThrottleId = null;
                        self.zidx.zSetScrollPosition();
                    });
                }
            });
            // Ask the host to repeat its handshake after the SPA has initialized.
            self.iframeChildManager.reportHeight();
            postToParent({type: 'PeakIDXChildReady'});
        }
    }

    // ── Save buttons ──

    bindSaveButtons(){
        let self=this;
        $(".zidxSearchResultSave", this.zidx.peakidxShadowRoot).each(function (this: any) {
            let $this = $(this);
            let listingId = $this.attr("data-id");
            if (!listingId) {
                return;
            }
            let isSaved = SavedListingRepository.getInstance(self.zidx).isSaved(listingId);
            $this.attr('data-saved', ""+isSaved);
            if (isSaved) {
                $this.removeClass("fa-heart-o");
                $this.addClass("fa-heart");
            } else {
                $this.removeClass("fa-heart");
                $this.addClass("fa-heart-o");
            }
        });
        $(".zidxSearchResultSave", this.zidx.peakidxShadowRoot).off("mouseover").on("mouseover", this.onSearchResultMouseOver);
        $(".zidxSearchResultSave", this.zidx.peakidxShadowRoot).off("mouseout").on("mouseout", this.onSearchResultMouseOut);
        $(".zidxSearchResultSave", this.zidx.peakidxShadowRoot).off("click").on("click", async function(this:HTMLElement, e:JQuery.ClickEvent){
            e.stopPropagation();
            e.preventDefault();
            let listingId = $(this).attr("data-id");
            if (!listingId) {
                peakAlert("Unexpected error");
                return;
            }
            let uniqueId = parseInt($(this).attr("data-unique-id") || "0", 10);
            let saved = $(this).attr("data-saved") || 'false'
            const repo = SavedListingRepository.getInstance(self.zidx);
            const $button = $(this);

            if (saved == 'true') {
                repo.removeByStringId(listingId, uniqueId);
                $button.attr("data-saved", 'false');
                $button.removeClass("fa-heart");
                $button.addClass("fa-heart-o");
                if($($button[0].parentNode!.parentNode!).hasClass("zidxSavedListingContainer")){
                    $($button[0].parentNode!.parentNode!).remove();
                }
            } else {
                if (!repo.canSaveOrHide()) {
                    self.zidx.showLoginForm();
                    return;
                }
                repo.saveByStringId(listingId, uniqueId);
                $button.attr("data-saved", 'true');
                $button.removeClass("fa-heart-o");
                $button.addClass("fa-heart");
            }
        });
    }

    // ── Mouse event handlers ──

    onSearchResultMouseOver = function (this: any, e: JQuery.MouseOverEvent) {
        const $target = $(e.target);
        if ($target.is(".zidxSearchResultSave") && $target.attr("data-saved") != 'true') {
            if ($target.attr("data-saved") != 'true') {
                $target.removeClass("fa-heart-o");
                $target.addClass("fa-heart");
            }
        }
    }

    onSearchResultMouseOut = function (this: any, e: JQuery.MouseOutEvent) {
        const $target = $(e.target);
        if ($target.is(".zidxSearchResultSave") && $target.attr("data-saved") != 'true') {
            $target.removeClass("fa-heart");
            $target.addClass("fa-heart-o");
        }
    }

    // ── Misc helpers ──

    setFieldFromLocalStorage(containerSelector:string, field:string, id:string){
        let val=localStorage.getItem("zidx."+field);
        if(val!=null && val!="undefined"){
            $("#"+id, this.zidx.peakidxShadowRoot).val(val);
        }
        $(containerSelector+" #"+id, this.zidx.peakidxShadowRoot).off("input").on("input", function(this:HTMLInputElement){
            let val=$(this).val()!;
            localStorage.setItem("zidx."+field, val);
        });
    }

    isFreeTrial(): boolean {
        return this.useFreeTrial && this.zidx.options.freeTrial
    }

    // ── Init ──

    init(renderSaveButton: boolean, openInNewTab: boolean, useFreeTrial: boolean, loadCurrentSearchFromLocal: boolean) {
        this.renderSaveButton = renderSaveButton;
        this.openInNewTab = openInNewTab;
        this.useFreeTrial = useFreeTrial;
        let self=this;

        if (this.zidx.zIsTouchscreen()) {
            $(".zidxSearchFullscreenLink", this.zidx.peakidxShadowRoot).hide();
        } else {
            $(".zidxSearchFullscreenLink", this.zidx.peakidxShadowRoot).hide();
        }
        if ($("#zidx_searchhome_loaded", this.zidx.peakidxShadowRoot).attr("data-loaded") == "0") {
            this.setupSearchForm(loadCurrentSearchFromLocal);
            $("#zidx_searchhome_loaded", this.zidx.peakidxShadowRoot).attr("data-loaded", "1");
        }

        this.searchDomain = $(".zidxSearchRoot", this.zidx.peakidxShadowRoot).attr("data-domain") || "";

        $(".zidxSearchResultListingContainer", this.zidx.peakidxShadowRoot).each(function(this:HTMLElement){
            let id=$(this).attr("data-id")!;
            if(SavedListingRepository.getInstance(self.zidx).isHidden(id)){
                $(this).hide();
            }
        });
        if($(".zidxSearchResultsDisabledContainer", this.zidx.peakidxShadowRoot).length>0) {
            $(".zidxSearchLayoutLinks", this.zidx.peakidxShadowRoot).hide();
            $(".zidxLoadMoreContainer", this.zidx.peakidxShadowRoot).hide();
        }else{
            $(".zidxSearchLayoutLinks", this.zidx.peakidxShadowRoot).show();
        }
        if(this.locationMegaMenu) {
            this.locationMegaMenu.init();
        }
    }
    resetForNavigation() {
        this.lastPostObj = new ZIDXSearchFields();
        this.listingData = new ZIDXListingData();
        this.currentOffset = 0;
        this.listingDataOffsetsLoaded = {};
        this.listingDataOffsetsLoading = {};
        this.resetListingData = true;
        this.mapLoaded = false;                    // force map iframe markers to reload
        this.infiniteScroll = null;                // drop stale panels/observers
        this.aiSearchIntegration = null;           // force AI chat/session rebuild from new URL
        $("#zidx_searchhome_loaded", this.zidx.peakidxShadowRoot).attr("data-loaded", "0");
    }

    // ── Map ──

    hideMap() {
        if (!this.mapLoaded) {
            return;
        }
        if (typeof this.zidx.zidxMap != "undefined") {
            this.zidx.zidxMap.hideMap();
        }
    }

    loadMap(loadCallback: Function) {
        let self=this;
        if (this.mapLoaded) {
            loadCallback();
            return;
        }
        this.zidx.zidxMap.loadMapIframe();
        if (typeof this.listingData.averageLatitude == "undefined" || this.listingData.averageLatitude == 0) {
            this.listingData.averageLatitude = 39;
            this.listingData.averageLongitude = -97;
        }
        this.zidx.zidxMap.mapIframePromise?.then(function(response:any){
            self.mapLoaded=true;
            loadCallback();
        }).catch(function(error:any){
            console.error("Error loading map iframe:", error);
        });
    }

    // ── Fullscreen ──

    openFullscreen(elem: HTMLElement) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else {
            // @ts-ignore
            if (elem.webkitRequestFullscreen) {
                // @ts-ignore
                elem.webkitRequestFullscreen();
            } else { // @ts-ignore
                if (elem.msRequestFullscreen) {
                    // @ts-ignore
                    elem.msRequestFullscreen();
                }
            }
        }
    }

    closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else { // @ts-ignore
            if (document.webkitExitFullscreen) {
                // @ts-ignore
                document.webkitExitFullscreen();
            } else {
                // @ts-ignore
                if (document.msExitFullscreen) {
                    // @ts-ignore
                    document.msExitFullscreen();
                }
            }
        }
    }

    // ── Generic helpers ──

    zso(obj: any, varName: string, isNumber?: boolean, defaultValue?: any) {
        if (typeof isNumber === "undefined") isNumber = false;
        if (typeof defaultValue === "undefined") defaultValue = false;
        let tempVar: any = "";
        if (isNumber) {
            if (this.keyExists(obj, varName)) {
                tempVar = obj[varName];
                if (!isNaN(tempVar)) {
                    return tempVar;
                } else {
                    if (defaultValue !== "") {
                        return defaultValue;
                    } else {
                        return 0;
                    }
                }
            } else {
                if (defaultValue !== "") {
                    return defaultValue;
                } else {
                    return 0;
                }
            }
        } else {
            if (this.keyExists(obj, varName)) {
                return obj[varName];
            } else {
                return defaultValue;
            }
        }
    }

    keyExists(obj: any, key: string) {
        return (key in obj);
    }

    urlAppend(theLink: string, appendString: string) {
        if (theLink.indexOf("?") !== -1) {
            return theLink + "&" + appendString;
        } else {
            return theLink + "?" + appendString;
        }
    }

    // ── Delegates to ListingRenderer ──

    numberFormat(value: number): string { return numberFormat(value); }
    htmlEditFormat(value: any): any { return htmlEditFormat(value); }
    timestampToDateFormat(UNIX_timestamp: number) { return timestampToDateFormat(UNIX_timestamp); }
    urlEncode(value: string, escapeWith: string) { return urlEncode(value, escapeWith); }
    getListingURL(ss: ZIDXListingSummary) { return getListingURL(this, ss); }
    getLayoutString(id: number): string { return getLayoutString(this, id); }
    renderListingThumbnailList(ss: ZIDXListingSummary, panel: InfiniteScrollPanel): string { return renderListingThumbnailList(this, ss, panel); }
    renderListingThumbnailDetail(ss: ZIDXListingSummary, panel: InfiniteScrollPanel): string { return renderListingThumbnailDetail(this, ss, panel); }
    displayListings() { displayListings(this); }
    listingPanelRenderCallback(panel: InfiniteScrollPanel) { listingPanelRenderCallback(this, panel); }
    setupListingSearchInfiniteScroll() { setupListingSearchInfiniteScroll(this); }

    // ── Delegates to SearchEngine ──

    mapArrayToObject(arrData: string[], arrKeys: string[], obj: any) { mapArrayToObject(this, arrData, arrKeys, obj); }
    doSearchCountCallback(s: string) { doSearchCountCallback(this, s); }
    doSearchCallback(s: string, offset: number) { doSearchCallback(this, s, offset); }
    parseSearchData() { parseSearchData(this); }
    updateListingData() { updateListingData(this); }
    doSearchCallbackError(r: any) { doSearchCallbackError(this, r); }
    doSearchCountCallbackError(r: any) { doSearchCountCallbackError(this, r); }
    parseListingIds(s: string): string { return parseListingIds(s); }
    buildJsonSearch(ss: ZIDXSearchFields, countOnly: boolean): any { return buildJsonSearch(this, ss, countOnly); }
    setCheckboxValues(fieldName: string, values: string[]) { setCheckboxValues(this, fieldName, values); }
    static firstLetterCaps(s: string): string { return firstLetterCaps(s); }
    decodeNativeSearch(qs: string, isJSON: boolean, callback?: () => void) { decodeNativeSearch(this, qs, isJSON, callback); }
    applySearchParamsToForm(sp: any, callback?: () => void) { applySearchParamsToForm(this, sp, callback); }
    parseInQuery(query: string) { return parseInQuery(query); }
    async doSearch(postObj: ZIDXSearchFields, forceSearch: boolean) { return doSearch(this, postObj, forceSearch); }
    dedupeSearchForm(postObj: any): ZIDXSearchFields { return dedupeSearchForm(this, postObj); }
    limitTo32Values(fieldName: string, searchFields: ZIDXSearchFields, postObj: any) { limitTo32Values(this, fieldName, searchFields, postObj); }
    checkForSearchFormChanges(forceSearch: boolean, resetListingData: boolean) { checkForSearchFormChanges(this, forceSearch, resetListingData); }

    // ── Delegates to SearchFormUI ──

    getLabel(defaultLabel: string, from: string, to: string, suffix: string): string { return getLabel(defaultLabel, from, to, suffix); }
    updateSearchFormLabels(postObj: ZIDXSearchFields) { updateSearchFormLabels(this, postObj); }
    updateLabelValues(defaultLabel: string, className: string): string { return updateLabelValues(this, defaultLabel, className); }
    updateMoreLocationLabel() { updateMoreLocationLabel(this); }
    updateSearchCounts(postObj: ZIDXSearchFields) { updateSearchCounts(this, postObj); }
    closeMorePopup() { closeMorePopup(this); }
    relocateMegaMenu(inFilter: boolean) { relocateMegaMenu(this, inFilter); }
    searchUpdateMorePopup() { searchUpdateMorePopup(this); }
    idxSearchResize() { idxSearchResize(this); }
    loadCurrentSearchCriteria(loadCurrentSearchFromLocal: boolean) { loadCurrentSearchCriteria(this, loadCurrentSearchFromLocal); }
    setupSearchForm(loadCurrentSearchFromLocal: boolean) { setupSearchForm(this, loadCurrentSearchFromLocal); }
    setupSearchFormOnce() { setupSearchFormOnce(this); }
}
